import "./App.css";
import Logo from "../../assets/icons/samtree-logo.png";
import SamWatch from "../../assets/icons/intro/pc/watch2_ok_n.png"
import iSamWatch from "../../assets/icons/intro/pc/watch2_ok_n_c.png";
import YamWatch from "../../assets/icons/intro/pc/yam.png"
import iYamWatch from "../../assets/icons/intro/pc/yam_c.png"
import SamTheme from "../../assets/icons/intro/pc/theme2_n.png"
import iSamTheme from "../../assets/icons/intro/pc/theme2_n_c.png"
import SamStudio from "../../assets/icons/intro/pc/studio2_n.png"
import iSamStudio from "../../assets/icons/intro/pc/studio2_n_c.png"
import SamWatchM from "../../assets/icons/intro/mobile/watch_m_ok_n.png"
import YamWatchM from "../../assets/icons/intro/mobile/yam2_ok_n.png"
import SamThemeM from "../../assets/icons/intro/mobile/theme2_ok_n.png"
import SamStudioM from "../../assets/icons/intro/mobile/studio2_ok_n.png"
import PageNotAvailable from "../common/Maintanance/notAvailablePage"

import { METHOD, apiCall } from "../../service/baseApiCall";
import { useNavigate } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import { getDataFromLocalStorage, jwtManager, jwtManagerType, useConfirm } from "./utils/util"
import { HEALTH_CHECK } from "../../service/apiEndPoints";

export const App = () => {
  const [loader, setLoader]  = useState<boolean>(false)
  const [isNotAvailable, setIsNotAvailable] = useState<boolean>(false)
  const navigate = useNavigate(),
    [isLoggedIn, setIsLoggedIn] = useState(false),
    isLongPress = useRef<any>(),
    timerRef = useRef<any>();
  let count = 0;
  const clickCount = () => {
    count++;
    if (count === 10) navigate("/login");
  };
  const startPressTimer = () => {
    isLongPress.current = false;
    timerRef.current = setTimeout(() => {
      isLongPress.current = true;
    }, 10);
  };
  
  // const logoutConfirm = () => {
  //   jwtManager(jwtManagerType.remove)

  //   window.location.reload()
  // }
  // const logoutCancel = () => { }
  // let adminLogout = useConfirm( "로그아웃 하시겠습니까?", logoutConfirm, logoutCancel )

  const introImgType = [
    {leave: SamWatch,  over: iSamWatch, mobile: SamWatchM, navigate: "/samwatch"},
    {leave: YamWatch,  over: iYamWatch, mobile: YamWatchM, navigate: "/yamwatch"},
    {leave: SamTheme,  over: iSamTheme, mobile: SamThemeM, navigate: "/samtheme"},
    {leave: SamStudio, over: iSamStudio, mobile: SamStudioM, navigate: "/samstudio"},
  ]

  const healthCheck = () => {
    apiCall(
        HEALTH_CHECK,
        {},
        (res: any) => {
            if (res.success === true) {
              setLoader(true)
            }
        },
        (err: any) => {
            setLoader(false)
            setIsNotAvailable(true)
        },
        METHOD.GET,
        {timeout: process.env.REACT_APP_AXIOS_TIMEOUT}
    )
  }

  useEffect( () => { 
    healthCheck()
    if( typeof(getDataFromLocalStorage("isLoggedIn")) === "object" ) { setIsLoggedIn(false) }
    else { setIsLoggedIn(true) }
  }, [])

  return (
    <div className="bg-black h-[100dvh] overflow-hidden sm:min-h-screen sm:h-fit sm:overflow-visible flex flex-col justify-center w-full max-w-full py-6 sm:py-10 md:p-12 lg:px-52">
      <div className="shrink-0 sm:mt-2 xl:mt-4 sm:h-[80px]" style={{"textAlign": "center"}}>
        <img
          className="h-14 sm:h-20 lg:h-28 xl:h-[7.5rem] 2xl:h-[8.25rem] mx-auto"
          src={Logo}
          alt=""
        />
      </div>
      <div className="hidden sm:flex w-full max-w-full min-w-0 mx-auto md:mx-5 mt-10 2xl:mt-14 justify-evenly items-center gap-2 [&>*]:hover:cursor-pointer">
        {
          (isNotAvailable === false && loader) || process.env.REACT_APP_DEBUG === "true" ?
            introImgType.map( img => (
              <div key={img.navigate} className="relative flex min-w-0 flex-1 items-center justify-center p-2 md:p-4">
                <img
                  onMouseOver={e=> (e.currentTarget.src=img.over)}
                  onMouseLeave={e => (e.currentTarget.src=img.leave)}
                  onClick={() => navigate(img.navigate)}
                  className="h-auto max-h-72 w-auto max-w-full object-contain xl:max-h-[22rem] 2xl:max-h-[26rem]"
                  src={img.leave}
                  alt=""
                />
              </div>   
            ))
          : isNotAvailable && loader === false ? 
            <PageNotAvailable />
          : isNotAvailable === false && loader === false ?
              <div className="h-2 w-4 bg-slate-600 rounded mt-2">
              </div> 
          : <PageNotAvailable />
        }
      </div>
      <div className="mx-6 mt-4 flex flex-1 flex-col min-h-0 min-w-0 sm:hidden gap-2">
        {
          (isNotAvailable === false && loader === true) || process.env.REACT_APP_DEBUG === "true" ?
            introImgType.map( img => (
              <div key={img.navigate} className="relative min-h-0 flex-1">
                <img
                  onTouchStart={() => startPressTimer()}
                  onTouchEnd={() => {
                    !isLongPress.current && navigate(img.navigate);
                    clearTimeout(timerRef.current);
                  }}
                  onClick={() => navigate(img.navigate)}
                  className="absolute inset-0 h-full w-full object-contain"
                  src={img.mobile}
                  alt=""
                />
              </div>
            ))
          : isNotAvailable && loader === false ? 
            <PageNotAvailable />
          : isNotAvailable === false && loader === false ?
              <div className="h-2 w-4 bg-slate-600 rounded mt-2">
              </div> 
          : <PageNotAvailable />
        }
      </div>
      <p className="shrink-0 text-white text-center px-5 text-xs xl:text-sm mt-4 sm:mt-10">
        COPYRIGHT ©.
        <span onClick={() => clickCount()}>SAMTREE&nbsp;</span>
        ALL RIGHTS RESERVED
      </p>
    </div>
  );
};
